var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecommendations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "recommendations") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 27.992,
    r: 2,
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,1A25.028,25.028,0,0,0,9,26l-.017,3-5,9.183a2,2,0,0,0,.861,2.744L8.983,43,9,50a7.009,7.009,0,0,0,7,7h9v6H51V44.294A24.975,24.975,0,0,0,34,1Zm2.535,24.491-2.75.2a6.968,6.968,0,0,1-.789,1.9L34.8,29.676a.5.5,0,0,1-.025.681l-1.414,1.414a.5.5,0,0,1-.68.024L30.6,29.988a6.962,6.962,0,0,1-1.9.789l-.2,2.75a.5.5,0,0,1-.5.465H26a.5.5,0,0,1-.5-.465l-.2-2.75a6.962,6.962,0,0,1-1.9-.789L21.316,31.8a.5.5,0,0,1-.68-.024l-1.414-1.414a.5.5,0,0,1-.025-.681L21,27.591a6.968,6.968,0,0,1-.789-1.9l-2.75-.2a.5.5,0,0,1-.465-.5v-2a.5.5,0,0,1,.465-.5l2.75-.2a6.968,6.968,0,0,1,.789-1.9L19.2,18.31a.5.5,0,0,1,.025-.682l1.414-1.414a.5.5,0,0,1,.68-.024L23.4,18a6.966,6.966,0,0,1,1.9-.788l.2-2.751a.5.5,0,0,1,.5-.465h2a.5.5,0,0,1,.5.465l.2,2.751A6.966,6.966,0,0,1,30.6,18l2.085-1.806a.5.5,0,0,1,.68.024l1.414,1.414a.5.5,0,0,1,.025.682L33,20.394a6.968,6.968,0,0,1,.789,1.9l2.75.2a.5.5,0,0,1,.465.5v2A.5.5,0,0,1,36.535,25.491Zm14.465,3a.5.5,0,0,1-.438.5l-1.727.216a4.964,4.964,0,0,1-.561,1.348l1.071,1.376a.5.5,0,0,1-.041.66L48.6,33.3a.5.5,0,0,1-.66.041L46.56,32.266a4.9,4.9,0,0,1-1.348.561L45,34.555a.5.5,0,0,1-.5.437h-1a.5.5,0,0,1-.5-.437l-.216-1.728a4.9,4.9,0,0,1-1.348-.561l-1.376,1.071a.5.5,0,0,1-.66-.041l-.708-.708a.5.5,0,0,1-.041-.66l1.071-1.376a4.964,4.964,0,0,1-.561-1.348l-1.728-.216a.5.5,0,0,1-.437-.5v-1a.5.5,0,0,1,.437-.5l1.728-.216a4.958,4.958,0,0,1,.561-1.347l-1.071-1.376a.5.5,0,0,1,.041-.66l.708-.708a.5.5,0,0,1,.66-.041l1.376,1.07a4.964,4.964,0,0,1,1.348-.561L43,21.43a.5.5,0,0,1,.5-.438h1a.5.5,0,0,1,.5.438l.216,1.727a4.964,4.964,0,0,1,1.348.561l1.376-1.07a.5.5,0,0,1,.66.041l.708.708a.5.5,0,0,1,.041.66l-1.071,1.376a4.958,4.958,0,0,1,.561,1.347L50.562,27a.5.5,0,0,1,.438.5Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 23.992,
    r: 3,
    "data-color": "color-2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendations);
export default __webpack_public_path__ + "static/media/recommendations.1cfba8547b194d91af1bb4ffa1c9645d.svg";
export { ForwardRef as ReactComponent };